import { useState, useEffect } from 'react'
import { CONFIG } from '../config'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ minutes: 0, seconds: 0 })

  useEffect(() => {
    const getEndTime = () => {
      const stored = localStorage.getItem('countdown_end')
      if (stored && parseInt(stored) > Date.now()) {
        return parseInt(stored)
      }
      const newEnd = Date.now() + CONFIG.COUNTDOWN_MINUTES * 60 * 1000
      localStorage.setItem('countdown_end', newEnd.toString())
      return newEnd
    }

    let endTime = getEndTime()

    const interval = setInterval(() => {
      const now = Date.now()
      if (now >= endTime) {
        endTime = Date.now() + CONFIG.COUNTDOWN_MINUTES * 60 * 1000
        localStorage.setItem('countdown_end', endTime.toString())
      }

      const diff = endTime - now
      setTimeLeft({
        minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((diff % (1000 * 60)) / 1000),
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
